import "./component-library259.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "ProductOfferShadow"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "product-offer-shadow" });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "0fc18702",
  null,
  null
);
const ProductOfferShadow = __component__.exports;
export {
  ProductOfferShadow as default
};
